import { render, staticRenderFns } from "./SorterArray.vue?vue&type=template&id=4115d7cd"
import script from "./SorterArray.vue?vue&type=script&lang=js"
export * from "./SorterArray.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports